import RouterView from '@/page/main/DefaultRouterView'
import List from '@/page/personnel/list'
import UserInfo from '@/page/personnel/create'
import HumanInfo from '@/page/personnel/humanInfo'
import VacationApply from '@/page/personnel/vacationApply'
import VacationList from '@/page/personnel/vacationList'
import TransferApply from '@/page/personnel/transferApply'
import TransferList from '@/page/personnel/transferList'
import KqApply from '@/page/personnel/kqApply'
import KqList from '@/page/personnel/kqList'

export default {
  path: '/Personnel',
  component: RouterView,
  children: [{
    path: 'List',
    meta: {
      type: ['personnel', 'list'],
      title: '员工档案'
    },
    component: List
  }, {
    path: 'Info/:archivesId?',
    meta: {
      type: ['personnel', 'list'],
      title: '编辑员工档案'
    },
    component: UserInfo
  }, {
    path: 'Human/Info/:archivesId?',
    meta: {
      type: ['personnel', 'list'],
      title: '编辑个人信息'
    },
    component: HumanInfo
  }, {
    path: 'Vacation/Apply/:applyId?',
    meta: {
      type: ['personnel', 'vacationList'],
      title: '新建请假审批'
    },
    component: VacationApply
  }, {
    path: 'Vacation/List',
    meta: {
      type: ['personnel', 'vacationList'],
      title: '请假/休假审批列表'
    },
    component: VacationList
  }, {
    path: 'Transfer/Apply/:applyId?',
    meta: {
      type: ['personnel', 'transferList'],
      title: '人员调动审批'
    },
    component: TransferApply
  }, {
    path: 'Transfer/List',
    meta: {
      type: ['personnel', 'transferList'],
      title: '人员调动审批列表'
    },
    component: TransferList
  },{
    path: 'Kq/Apply/:applyId?',
    meta: {
      type: ['personnel', 'kqList'],
      title: '考勤未签到说明'
    },
    component: KqApply
  }, {
    path: 'Kq/List',
    meta: {
      type: ['personnel', 'kqList'],
      title: '考勤未签到说明审批列表'
    },
    component: KqList
  }, ]
}


// WEBPACK FOOTER //
// ./src/router/personnel.js